export const heading =  {
    size: '24px',
    weight: '600'
}

export const text = {
    size: '18px',
}